/* QUESTIONS ROUTE CREATE */
const ListQuestions = () => import(/* webpackPrefetch: true */ '@/components/course/CreateQuestion/List.vue');
const VocabularyQuestions = () => import(/* webpackPrefetch: true */ '@/components/course/CreateQuestion/Vocabulary.vue');
const VoiceRecordQuestions = () => import(/* webpackPrefetch: true */ '@/components/course/CreateQuestion/VoiceRecord.vue');
const ListeningQuestions = () => import(/* webpackPrefetch: true */ '@/components/course/CreateQuestion/Listening.vue');
const ConstructorWordQuestions = () => import(/* webpackPrefetch: true */ '@/components/course/CreateQuestion/ConstructorWord.vue');
const ReadingQuestions = () => import(/* webpackPrefetch: true */ '@/components/course/CreateQuestion/Reading.vue');
const MatchingQuestions = () => import(/* webpackPrefetch: true */ '@/components/course/CreateQuestion/Matching.vue');
const SentenceRecordQuestions = () => import(/* webpackPrefetch: true */ '@/components/course/CreateQuestion/SentenceRecord.vue');
const FillTheBlankQuestions = () => import(/* webpackPrefetch: true */ '@/components/course/CreateQuestion/FillTheBlank.vue');

const routes = [
  {
    path: "/questions/:id_course/:id_topic/:id_activity/:activity_type",
    name: "List Questions",
    component: ListQuestions,
    meta: {
      title: "List Questions"
    }
  },
  {
    path: "/questions/vocabulary/create/:id_course/:id_topic/:id_activity/:activity_type",
    name: "Vocabulary Questions Create",
    component: VocabularyQuestions,
    meta: {
      title: "Vocabulary Questions Create"
    }
  },
  {
    path: "/questions/voices/create/:id_course/:id_topic/:id_activity/:activity_type",
    name: "Voice Record Questions Create",
    component: VoiceRecordQuestions,
    meta: {
      title: "Voice Record Questions Create"
    }
  },
  {
    path: "/questions/listening/create/:id_course/:id_topic/:id_activity/:activity_type",
    name: "Listening Questions Create",
    component: ListeningQuestions,
    meta: {
      title: "Listening Questions Create"
    }
  },
  {
    path: "/questions/constructorword/create/:id_course/:id_topic/:id_activity/:activity_type",
    name: "Constructor Word Questions Create",
    component: ConstructorWordQuestions,
    meta: {
      title: "Constructor Word Questions Create"
    }
  },
  {
    path: "/questions/reading/create/:id_course/:id_topic/:id_activity/:activity_type",
    name: "Reading Questions Create",
    component: ReadingQuestions,
    meta: {
      title: "Reading Questions Create"
    }
  },
  {
    path: "/questions/matching/create/:id_course/:id_topic/:id_activity/:activity_type",
    name: "Matching Image Questions Create",
    component: MatchingQuestions,
    meta: {
      title: "Matching Image Questions Create"
    }
  },
  {
    path: "/questions/sentencerecord/create/:id_course/:id_topic/:id_activity/:activity_type",
    name: "Sentence Record Questions Create",
    component: SentenceRecordQuestions,
    meta: {
      title: "Sentence Record Questions Create"
    }
  },
  {
    path: "/questions/filltheblank/create/:id_course/:id_topic/:id_activity/:activity_type",
    name: "Fill The Blank Questions Create",
    component: FillTheBlankQuestions,
    meta: {
      title: "Fill The Blank Questions Create"
    }
  },
]

export default routes.map(route => {
  const meta = {
    all: false, 
    public: false,
    title: route.meta.title
  }
    return { ...route, meta }
})